import { CONTINENTS, COUNTRY_CONTINENTS, CURRENT_COUNTRY_ID } from '~constants/environment';

export const isEurope = () => COUNTRY_CONTINENTS[CURRENT_COUNTRY_ID][0] === CONTINENTS.EU;
